import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import BoundingRectChangeDetector from 'components/utils/BoundingRectChangeDetector';

const ShowMoreContainer = styled.div`
  width: 100%;
  max-height: ${({ maxHeight }) => maxHeight};
  overflow: hidden;
  position: relative;
`;

const showMoreBackground = (isShowMore, bgRBG) => {
  if (isShowMore) return 'unset';
  const showMoreRGBString = bgRBG.join(', ');
  return `linear-gradient(
    rgba(${showMoreRGBString}, 0) 0%,
    rgba(${showMoreRGBString}, 1) 75%,
    rgba(${showMoreRGBString}, 1) 100%
  )`;
};

const ShowMoreText = styled.div`
  width: 100%;
  position: ${({ isShowMore }) => (isShowMore ? 'unset' : 'absolute')};
  bottom: 0;
  font-size: 16px;
  line-height: 16px;
  padding-top: ${({ isShowMore }) => (isShowMore ? '0' : '48px')};
  display: ${({ enabled }) => (enabled ? 'block' : 'none')};
  color: #5C8DF3;
  cursor: pointer;
  background: ${({ isShowMore, backgroundRGB }) => showMoreBackground(isShowMore, backgroundRGB)};
`;

const ShowMore = ({
  className, children, maxHeight, backgroundRGB,
}) => {
  const { t } = useTranslation();
  const [isOverHeight, setIsOverHeight] = useState();
  const [isShowMore, setIsShowMore] = useState();

  return (
    <ShowMoreContainer className={className} maxHeight={isShowMore ? 'unset' : `${maxHeight}px`}>
      <BoundingRectChangeDetector onChange={(bounding) => setIsOverHeight(bounding.height > maxHeight)} detectPosition={false}>
        {children}
      </BoundingRectChangeDetector>
      <ShowMoreText enabled={isOverHeight} onClick={() => setIsShowMore(!isShowMore)} isShowMore={isShowMore} backgroundRGB={backgroundRGB}>
        {isShowMore ? t('show.less') : t('show.more')}
      </ShowMoreText>
    </ShowMoreContainer>
  );
};

ShowMore.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  maxHeight: PropTypes.number.isRequired,
  backgroundRGB: PropTypes.arrayOf(PropTypes.number),
};

ShowMore.defaultProps = {
  className: '',
  backgroundRGB: [255, 255, 255],
};

export default ShowMore;
